module.exports = __webpack_public_path__ + "img/approve-list7.c82ac270.png";